<template>
  <div class="dashboard-topbar">
    <div class="dashboard-topbar-left">
      {{ categoryname }}
    </div>
    <div class="dashboard-topbar-title">
      {{ dashboardtitle }}
    </div>
    <div class="dashboard-topbar-back">
      <el-button @click="goBack" type="goback"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['categoryname', 'dashboardtitle'],
  methods: {
    goBack: function(){
      this.$router.push({name: 'CombinationAnalysisTest'})
    },
  }
}
</script>